import { render, staticRenderFns } from "./scrolldown-primary.vue?vue&type=template&id=6c82af90&scoped=true"
import script from "./scrolldown-primary.vue?vue&type=script&lang=js"
export * from "./scrolldown-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82af90",
  null
  
)

export default component.exports